// ==============================|| PRESET THEME - DEFAULT ||============================== //

// Custom Indigo palette — modern SaaS aesthetic (Linear/Stripe/Vercel inspired).
// 10 shades from light to dark, designed to match the login page's indigo + pink theme.
// Pink (#ec4899) is reserved as an accent for gradients/CTAs only — primary stays indigo
// to keep MUI button/link colors clean and accessible.
const trendingIndigo = [
  '#eef2ff', // 0  - lighter  → header backgrounds, footer totals (subtle indigo tint)
  '#e0e7ff', // 1  - 100      → hover tints, soft fills
  '#c7d2fe', // 2  - 200      → secondary fills, disabled states
  '#a5b4fc', // 3  - light    → light buttons, outlined hover
  '#818cf8', // 4  - 400      → bright accent
  '#6366f1', // 5  - main     → primary buttons, links, focus rings (indigo-500)
  '#4f46e5', // 6  - dark     → button hover (indigo-600)
  '#4338ca', // 7  - 700      → headings, deep emphasis (indigo-700)
  '#3730a3', // 8  - darker   → strongest contrast (indigo-800)
  '#312e81'  // 9  - 900      → deepest accent (indigo-900)
];

export default function Default(colors) {
  const { red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: trendingIndigo[0],
      100: trendingIndigo[1],
      200: trendingIndigo[2],
      light: trendingIndigo[3],
      400: trendingIndigo[4],
      main: trendingIndigo[5],
      dark: trendingIndigo[6],
      700: trendingIndigo[7],
      darker: trendingIndigo[8],
      900: trendingIndigo[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
}